import { TeamType } from 'src/types/domain.types';

export const generateTitle = (teams: TeamType[], lang: string) => {
  return teams?.length !== 2
    ? ''
    : `${teams[0][`name_${lang}` as keyof TeamType] ?? teams[0].name_en} vs ${
        teams[1][`name_${lang}` as keyof TeamType] ?? teams[1].name_en
      }`;
};
